import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

type CommentLoginModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const CommentLoginModal = ({ open, setOpen }: CommentLoginModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden w-[350px] md:w-[450px] ring-0 ring-transparent pt-[30px] pb-[30px]">
        <DialogHeader className="flex flex-col justify-center">
          <DialogTitle className="text-xl text-center text-black font-bold">ログインが必要です</DialogTitle>
        </DialogHeader>

        <div className="text-center text-base text-dark-gray mt-4 font-medium leading-[30px]">
          コメントや返信、いいね機能をご利用いただくには、ログインが必要です。
        </div>

        <div className="flex flex-col w-full items-center justify-center mt-5">
          <Button
            className="text-lg w-full h-[50px] text-white rounded-[10px] font-bold"
            variant="default"
            onClick={() => navigate("/login")}
          >
            ログインする
          </Button>
          <Button className="text-base mt-[24px] underline py-0" variant="link" onClick={() => setOpen(false)}>
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
